import { frontendURL } from '../../../helper/URLHelper';
import LandProcessesIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ardhisasa/land-processes'),
    name: 'ardhisasa_land_processes',
    component: LandProcessesIndex,
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
  },
];
